import { render, staticRenderFns } from "./Atividades_Tabela.vue?vue&type=template&id=84ffdef0"
import script from "./Atividades_Tabela.vue?vue&type=script&lang=js"
export * from "./Atividades_Tabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports